const formatDateString = (date) => {
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear().toString().slice(-2);
  const formatted = `${day}.${month}.${year}`;
  return formatted;
};

const formatDateStringFromDashToDot = (date) => {
  const dateParts = date.split("-");
  if (dateParts.length < 3) return "";
  return `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;
};

const formatDate = (date) =>
  date
    .toLocaleDateString("sr-RS", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit"
    })
    .replaceAll("/", ".")
    .slice(0, -1);

export { formatDateString, formatDateStringFromDashToDot, formatDate };
